import { BaseEnum } from './baseEnum';

const listIntegrationLinkTypeEnum: Array<IntegrationLinkTypeEnum> = [];

export class IntegrationLinkTypeEnum extends BaseEnum {
  static CHANGE_COST_CENTER = new IntegrationLinkTypeEnum(26, 'CHANGE_COST_CENTER', 'Mudança de centro de custo');
  static CHANGE_JOB_TITLE = new IntegrationLinkTypeEnum(27, 'CHANGE_JOB_TITLE', 'Mudança de função');
  static CHANGE_EMPLOYEE_PARAMS = new IntegrationLinkTypeEnum(35, 'CHANGE_EMPLOYEE_PARAMS', 'Alterar parâmetros do colaborador');

  constructor(public id: number, public value: string, public label: string) {
    super(id, value, label);
    listIntegrationLinkTypeEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listIntegrationLinkTypeEnum;
  }

  public static getLabel(type: number): string {
    const match = listIntegrationLinkTypeEnum.find(item => item.id === type);
    return match?.label ?? `Integração ${type}`;
  }

  public static toId(value: string | number | null | undefined): number | null {
    if (value == null || value === '') {
      return null;
    }

    if (typeof value === 'number' && !Number.isNaN(value)) {
      return value;
    }

    const normalized = `${value}`.trim();
    const numericValue = Number(normalized);
    if (!Number.isNaN(numericValue) && `${numericValue}` === normalized) {
      return numericValue;
    }

    const match = listIntegrationLinkTypeEnum.find(item => item.value === normalized);
    return match?.id ?? null;
  }

  public static toIds(values: Array<string | number> | null | undefined): number[] {
    if (!Array.isArray(values) || values.length === 0) {
      return [];
    }

    return values
      .map(value => IntegrationLinkTypeEnum.toId(value))
      .filter((value): value is number => value != null);
  }
}
